export default "__VITE_ASSET__BsixKPV9__"